// import DOMUtils from '../../auth/scripts/utils/DOMUtils';

import { pushEmailSubscriptionEvent } from '@utils/dataLayer';
import Messages from '../../auth/scripts/utils/Messages';
import FormValidator from '../../auth/scripts/utils/FormValidator';

class Newsletter {
  constructor(element) {
    this.element = element;
    this.form = this.element.querySelector('form.newsletter-form');

    if (!this.form) {
      return;
    }

    this.heading = this.element.querySelector('.newsletter__heading');
    this.body = this.element.querySelector('.newsletter__body');
    this.email = this.form.querySelector('.newsletter-form__field-email');
    this.emailInput = this.email.querySelector('input[type="email"]');
    this.emailError = this.email.querySelector('.form__field-error');
    this.submit = this.form.querySelector('button[type="submit"]');

    // Disable native validation to avoid :user-invalid styling.
    this.form.setAttribute('novalidate', '');

    const messageSource = this.form.dataset.messages ? this.form : this.element;
    this.messages = new Messages(messageSource);
    this.validator = new FormValidator(this.messages);

    this.email.addEventListener('focusout', this.validateForm);
    this.email.addEventListener('input', () => {
      if (this.emailError.innerHTML) {
        this.clearErrorState();
      }
      this.submit.removeAttribute('disabled');
    });
    this.email.addEventListener('focusin', this.clearErrorState);

    document.addEventListener('wpcf7mailsent', () => {
      this.setSuccessState();
      pushEmailSubscriptionEvent();
    }, false);
  }

  validateForm = () => {
    const valid = FormValidator.validateEmail(this.emailInput.value);
    if (valid) {
      this.submit.removeAttribute('disabled');
    } else {
      this.setErrorState(this.messages.getMessage('error_email_invalid'));
    }
  };

  setLoading = () => {
    this.submit.removeAttribute('disabled');
    this.submit.classList.add('newsletter-form__field-submit--loading');
    this.submit.setAttribute('aria-busy', 'true');
    // Update aria-hidden states
    const textSpan = this.submit.querySelector('.newsletter-form__field-submit-text');
    const busySpan = this.submit.querySelector('.newsletter-form__field-submit-busy');
    if (textSpan) textSpan.setAttribute('aria-hidden', 'true');
    if (busySpan) busySpan.setAttribute('aria-hidden', 'false');
  };

  setSubscribed = () => {
    this.submit.removeAttribute('disabled');
    this.submit.classList.add('newsletter-form__field-submit--subscribed');
    this.submit.removeAttribute('aria-busy');
    // Update aria-hidden states
    const busySpan = this.submit.querySelector('.newsletter-form__field-submit-busy');
    const successSpan = this.submit.querySelector('.newsletter-form__field-submit-success');
    if (busySpan) busySpan.setAttribute('aria-hidden', 'true');
    if (successSpan) successSpan.setAttribute('aria-hidden', 'false');
  };

  clearLoading = () => {
    this.submit.classList.remove('newsletter-form__field-submit--loading');
    this.submit.classList.remove('newsletter-form__field-submit--subscribed');
    this.submit.removeAttribute('aria-busy');
    // Reset aria-hidden states
    const textSpan = this.submit.querySelector('.newsletter-form__field-submit-text');
    const busySpan = this.submit.querySelector('.newsletter-form__field-submit-busy');
    const successSpan = this.submit.querySelector('.newsletter-form__field-submit-success');
    if (textSpan) textSpan.setAttribute('aria-hidden', 'false');
    if (busySpan) busySpan.setAttribute('aria-hidden', 'true');
    if (successSpan) successSpan.setAttribute('aria-hidden', 'true');
  };

  setSuccessState = () => {
    this.heading.innerHTML = this.element.dataset.successMessage;
    this.email.remove();
    this.body.classList.add('newsletter__body--success');
    this.body.ariaHidden = true;
    this.setSubscribed();
  };

  setErrorState = (message) => {
    const input = this.email.querySelector('.form__input');
    input.classList.add('form__input--error');
    input.setAttribute('aria-invalid', 'true');
    this.submit.setAttribute('disabled', '');
    this.clearLoading();
    if (message && this.emailError) {
      this.emailError.innerHTML = message;
    }
  };

  clearErrorState = () => {
    const input = this.email.querySelector('.form__input');
    input.classList.remove('form__input--error');
    input.removeAttribute('aria-invalid');
    this.emailError.innerHTML = '';
  };
}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  const newsletter = document.querySelector('.newsletter');
  if (newsletter) {
    // eslint-disable-next-line no-new
    new Newsletter(newsletter);
  }
});

export default Newsletter;
